import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

/**
 * O esqueleto da tela do carro. Repete a estrutura real na mesma ordem — topo com o nome e os
 * anos, galeria com a tira de miniaturas, painel da versão e a lista de versões — para o
 * conteúdo não empurrar a página quando a ilha monta.
 *
 * Sem wrapper de tema aqui: o Suspense renderiza isto DENTRO da div da ilha, que já tem as
 * classes .ranking-lp e .rkc (ver Views/RankingCarro/Index.cshtml).
 *
 * As caixas usam as classes reais (.rkc-palco, .rkc-painel, .rkc-item) porque é delas que vêm a
 * proporção da foto, o raio e o padding: o esqueleto ocupa o mesmo espaço que o conteúdo, e não
 * um retângulo aproximado.
 */
export default function RankingCarroSkeleton() {
  return (
    <div className="rkc-pagina">
      <div className="rkc-topo">
        <div className="rk-container">
          <Skeleton height={13} width={140} />
          <div style={{ marginTop: 16 }}>
            <Skeleton height={16} width={110} />
          </div>
          <div style={{ marginTop: 8 }}>
            <Skeleton height={42} width="46%" />
          </div>
          <div style={{ marginTop: 10 }}>
            <Skeleton height={15} width="34%" />
          </div>

          <div className="rkc-anos">
            <span className="rkc-anos-rotulo">Ano-modelo</span>
            <Skeleton borderRadius={12} height={40} width={122} />
          </div>
        </div>
      </div>

      <div className="rkc-destaque">
        <div className="rk-container rkc-destaque-grade">
          {/* O palco: a foto grande, na proporção real (a do .rkc-palco), para o painel ao
              lado não subir e descer quando a ilha monta. */}
          <div className="rkc-palco">
            <Skeleton borderRadius={12} height="100%" width="100%" />
          </div>

          {/* A coluna da direita: o cartão da versão e a faixa de preço do ano embaixo dele. */}
          <div className="rkc-lado">
            <div className="rkc-painel">
              <div className="rkc-painel-id">
                <Skeleton height={12} width={110} />
                <Skeleton height={24} width="70%" />
              </div>
              <div className="rkc-painel-nota">
                <Skeleton height={44} width={64} />
              </div>
              <div className="rkc-painel-dados">
                <Skeleton height={38} width={190} />
              </div>
              <div className="rkc-painel-acoes">
                <Skeleton borderRadius={50} height={46} width={210} />
              </div>
            </div>

            <div className="rkc-preco">
              <Skeleton borderRadius={6} height={10} />
              <div style={{ marginTop: 9 }}>
                <Skeleton height={30} width="100%" />
              </div>
            </div>
          </div>

          {/* A fita, embaixo das duas colunas: os três quadros encostados, como no real. */}
          <div className="rkc-faixa">
            <div className="rkc-tira">
              {Array.from({ length: 3 }).map((_item, i) => (
                <div className="rkc-tira-item" key={i}>
                  <Skeleton borderRadius={0} height={228} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="rkc-versoes">
        <div className="rk-container">
          <Skeleton height={28} width={240} />
          <div style={{ marginTop: 8, marginBottom: 20 }}>
            <Skeleton height={14} width="52%" />
          </div>
          <div className="rkc-lista">
            {Array.from({ length: 4 }).map((_item, i) => (
              <Skeleton borderRadius={16} height={92} key={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
